module.exports = __webpack_public_path__ + "img/keshavarzi-card-image.3e02427f.png";